import * as React from "react";
import styled from "styled-components";
import Badge from "components/bootstrap/Badge";
import { RowTitleButton, Row } from "common/components";
import { HoverForHelp } from "components/common";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
import { requiredLicenseMessage } from "illuminate/components/content-hub/utils";
const Title = styled(RowTitleButton)`
  & * {
    color: ${({ theme, $disabled }) => $disabled ? theme.colors.text.disabled : theme.colors.link.default} !important;
  }
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
`;
const TitleRenderer = ({ pack }) => {
  const { toggleSection } = useExpandedSections();
  const toggleExtraSection = () => toggleSection(pack.pack_id, "restFieldsExpandedSection");
  return /* @__PURE__ */ React.createElement(TitleContainer, null, /* @__PURE__ */ React.createElement(Title, { $disabled: !(pack.is_compatible && pack.included_in_bundle), onClick: toggleExtraSection }, pack.title), !pack.included_in_bundle && /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "xxs" }, /* @__PURE__ */ React.createElement(Badge, { bsStyle: "danger", bsSize: "xs" }, requiredLicenseMessage(pack.license))));
};
const StatusRenderer = ({ pack }) => {
  if (!pack.is_new && !pack.update_available) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "xxs" }, pack.is_new && /* @__PURE__ */ React.createElement(Badge, { bsStyle: "success", bsSize: "xs" }, "New"), pack.update_available && /* @__PURE__ */ React.createElement(Badge, { bsStyle: "info", bsSize: "xs" }, "Updated"));
};
export const columnRenderers = {
  attributes: {
    title: {
      renderCell: (_title, pack) => /* @__PURE__ */ React.createElement(TitleRenderer, { pack })
    },
    included_in_bundle: {
      staticWidth: "matchHeader",
      renderHeader: (title) => /* @__PURE__ */ React.createElement(React.Fragment, null, title, /* @__PURE__ */ React.createElement(HoverForHelp, { placement: "bottom", pullRight: false, displayLeftMargin: true }, "Availability based on the current active license type. Only licensed packs can be enabled.")),
      renderCell: (_value, pack) => pack.included_in_bundle ? /* @__PURE__ */ React.createElement(Badge, { bsStyle: "success", bsSize: "xs" }, "Licensed") : /* @__PURE__ */ React.createElement(Badge, { bsStyle: "danger", bsSize: "xs" }, "Unlicensed")
    },
    enabled: {
      staticWidth: 90,
      renderCell: (enable) => enable ? /* @__PURE__ */ React.createElement(Badge, { bsStyle: "success" }, "Enabled") : null
    },
    type: {
      staticWidth: 120,
      renderCell: (type) => /* @__PURE__ */ React.createElement(Badge, null, type)
    },
    status: {
      staticWidth: 90,
      renderCell: (_status, pack) => /* @__PURE__ */ React.createElement(StatusRenderer, { pack })
    },
    category: {
      staticWidth: 150,
      renderCell: (category) => /* @__PURE__ */ React.createElement(Badge, null, category)
    },
    pack_id: {
      staticWidth: 300
    }
  }
};
